import React, { useEffect } from "react";
import { CheckCircle, ExternalLink, X } from "lucide-react";

function BaselineDialogResultPopup({ closePopup, confirm, resultDialog, url }) {

    const passedCount = Array.isArray(resultDialog) ? (resultDialog[1] ?? 0) : (resultDialog?.passed ?? 0);
    const failedCount = Array.isArray(resultDialog) ? (resultDialog[3] ?? 0) : (resultDialog?.failed ?? 0);

    useEffect(() => {
        document.body.style.overflow = "hidden";

        const onKeyDown = (event) => {
            if (event.key === "Escape") {
                closePopup();
            }
        };

        document.addEventListener("keydown", onKeyDown);

        return () => {
            document.body.style.overflow = "";
            document.removeEventListener("keydown", onKeyDown);
        };
    }, [closePopup]);

    const onOkClick = () => {
        closePopup();
        confirm && confirm();
    };

    return (
        <div className="oct-shared-popup oct-shared-popup--baseline-result" role="dialog" aria-modal="true" aria-labelledby="oct-baseline-result-title">
            <div className="oct-shared-popup__backdrop" onClick={closePopup} />

            <div className="oct-shared-popup__dialog oct-shared-popup__dialog--compact oct-shared-popup__dialog--baseline-result" onClick={(event) => event.stopPropagation()}>
                <div className="oct-shared-popup__header">
                    <div className="oct-shared-popup__title-wrap">
                        <div className="oct-shared-popup__title-icon">
                            <CheckCircle size={18} />
                        </div>
                        <h4 id="oct-baseline-result-title" className="oct-shared-popup__title">
                            Baseline Result
                        </h4>
                    </div>

                    <button type="button" className="oct-shared-popup__close" onClick={closePopup} aria-label="Close popup">
                        <X size={18} />
                    </button>
                </div>

                <div className="oct-shared-popup__body oct-shared-popup__body--baseline-result">
                    <div className="oct-shared-popup__result-intro">
                        <p className="oct-shared-popup__result-eyebrow">Configurations Baseline</p>
                        <p className="oct-shared-popup__message">
                            Baseline application finished. Review the validation summary below or open the full validation page.
                        </p>
                    </div>

                    <div className="oct-shared-popup__result-grid">
                        <div className="oct-shared-popup__result-card oct-shared-popup__result-card--success">
                            <span className="oct-shared-popup__result-label">Passed Configurations</span>
                            <strong className="oct-shared-popup__result-value">{passedCount}</strong>
                        </div>

                        <div className="oct-shared-popup__result-card oct-shared-popup__result-card--danger">
                            <span className="oct-shared-popup__result-label">Failed Configurations</span>
                            <strong className="oct-shared-popup__result-value">{failedCount}</strong>
                        </div>
                    </div>

                    <a href={url} className="oct-shared-popup__result-link">
                        Open Validation Page
                        <ExternalLink size={16} />
                    </a>
                </div>

                <div className="oct-shared-popup__footer oct-shared-popup__footer--end">
                    <button type="button" className="btn oct-shared-popup__btn oct-shared-popup__btn--primary" onClick={onOkClick}>
                        OK
                    </button>
                </div>
            </div>
        </div>
    );
}

export default BaselineDialogResultPopup;
